var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTableSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6511 5.248L17.6665 0.375C17.4731 0.138 17.1784 0 16.8684 0H5.11118C4.80114 0 4.50644 0.138 4.31305 0.375L0.22412 5.375C-0.021461 5.676 -0.0695542 6.087 0.101329 6.434C0.27119 6.779 0.629329 7 1.02226 7H2.04654V16H4.09305V7H6.13956V11H8.18606V7H13.814V11H15.8605V7H17.907V16H19.9535V7H20.9573C20.9645 7 20.9706 7 20.9778 7C21.5426 7 22 6.553 22 6C22 5.7 21.8649 5.431 21.6511 5.248ZM17.8906 5H15.8461H13.8017H8.17788H6.13342H4.08895H3.1496L5.60337 2H16.3782L18.832 5H17.8906Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTableSmall);
export default __webpack_public_path__ + "static/media/ico-table-small.36d69991.svg";
export { ForwardRef as ReactComponent };